<template>
  <div>
    <!--タイトル-->
    <Header></Header>

    <!--詳細-->
    <div style="background-color: #434343">
      <div id="imageList" class="carousel slide" data-ride="false" data-interval="false">
        <div class="carousel-inner">

          <div class='carousel-item' v-for="(url,index) in images" :class="{'active':index==0}" v-bind:key="url">
            <img :src='url' style="max-width=400px"/>
          </div>

          <a class="carousel-control-prev" href="#imageList" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#imageList" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>

    <nav class="navbar fixed-bottom navbar-expand-sm navbar-dark bg-dark">
      <button class='btn btn-lg btn-secondary' v-on:click='prevAction'>戻る</button>
    </nav>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'

export default {
  mounted: function () {
    
  },
  methods: {
    ...mapActions('ImageModule', {
      'prevAction': 'prevAction'
    }),
  },
  computed: {
    ...mapGetters('ImageModule', {
      'images': 'images',
    })
  },
  components: {
    Header
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ImageDetail.vue